import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';
import { periodicidadePeriodo } from 'app/models';
import { datepickerModeDay, getDatepickeModeOptions } from '../datepicker/datepicker-mode';

@Component({
    selector: 'sgt-datepicker-range',
    templateUrl: './datepicker-range.component.html',
    styleUrls: ['./datepicker-range.component.less']
})
export class DatepickerRangeComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() startDate: Date;
    @Output() startDateChange = new EventEmitter<Date>();
    @Input() endDate: Date;
    @Output() endDateChange = new EventEmitter<Date>();

    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() autofocus = false;

    private options: any;
    /** Periodicidade do datepicker igual a Período */
    private periodicidade = periodicidadePeriodo.id;
    /** Mode de exibição do datepicker igual a diária */
    @Input() mode: number = datepickerModeDay.id;

    /** Opções personalizadas para o datepicker. Informar quando for o modo Custom */
    @Input() customOptions: any;

    datepicker: any;
    @ViewChild('inputDateRange', {static: true}) inputDateRange: ElementRef;

    @ViewChild('inputDateStart', {static: true}) inputDateStart: ElementRef;
    datepickerStart: any;
    /** Se o valor no input do datepicker da data inicial foi alterado */
    private isInputStartValueChanged = false;

    @ViewChild('inputDateEnd', {static: true}) inputDateEnd: ElementRef;
    datepickerEnd: any;
    /** Se o valor no input do datepicker da data final foi alterado */
    private isInputEndValueChanged = false;

    // Teclas que devem ser ignoradas
    private ignoresKeys: string[] = ['Tab', 'Enter', 'Shift', 'Control', 'Alt', 'Pause', 'CapsLock', 'Escape', ' ', 'PageUp', 'PageDown', 'End', 'Home', 'ArrowLeft', 'ArrowUp', 'ArrowRight', 'ArrowDown', 'Insert', 'Meta',
                                        'F1', 'F2', 'F3', 'F4', 'F5', 'F6', 'F7', 'F8', 'F9', 'F10', 'F11', 'F12', 'NumLock', 'ScrollLock', 'Dead', '!', '@', '#', '$', '%', '&', '*', '(', ')', '-', '_', '+', '=', '[', ']',
                                        '{', '}', '|', '\'', ';', ':', '"', `'`, ',', '.', '<', '>', '?'];

    ngAfterViewInit() {
        this.create();

        if (this.autofocus) {
            this.setFocus();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        for (const propName in changes) {
            if (propName === 'startDate') {
                if (changes[propName].isFirstChange()) {
                    return;
                }

                this.setStartDate(this.startDate);
            } else if (propName === 'endDate') {
                if (changes[propName].isFirstChange()) {
                    return;
                }

                this.setEndDate(this.endDate);
            }
        }
    }

    /** Seta o foco no input do datepicker */
    setFocus() {
        jQuery(this.inputDateStart.nativeElement).trigger('focus');
    }

    /** Exibe o calendário do datepicker */
    show() {
        this.datepicker.datepicker('show');
    }

    /** Cria o datepicker utilizando a biblioteca bootstrap-datepicker */
    private create() {
        this.options = getDatepickeModeOptions(this.mode, this.periodicidade);

        // Inicializando o range do bootstrap-datepicker
        this.datepicker = (jQuery(this.inputDateRange.nativeElement) as any).datepicker(this.options);
        this.datepicker.addClass('datepicker-range');

        // Inicializando a data inicial
        const elStart = (jQuery(this.inputDateStart.nativeElement) as any);
        elStart.mask(this.options.mask);
        this.inputDateStart.nativeElement.placeholder = this.options.placeholder;
        this.datepickerStart = elStart.datepicker(this.options)
                            .on('changeDate', (e: any) => this.onChangeDateStart(e))
                            .on('show.bs.modal', (e: any) => {
                                this.addRangeDayCssClass();
                                e.stopPropagation();
                            })
                            .on('shown.bs.modal', (e: any) => {
                                e.stopPropagation();
                            })
                            .on('hide.bs.modal', (e: any) => {
                                e.stopPropagation();
                            })
                            .on('hidden.bs.modal', (e: any) => {
                                e.stopPropagation();
                            });

        this.setStartDate(this.startDate);

        // Inicializando a data final
        const elEnd = (jQuery(this.inputDateEnd.nativeElement) as any);
        elEnd.mask(this.options.mask);
        this.inputDateEnd.nativeElement.placeholder = this.options.placeholder;
        this.datepickerEnd = elEnd.datepicker(this.options)
                            .on('changeDate', (e: any) => this.onChangeDateEnd(e))
                            .on('show.bs.modal', (e: any) => {
                                this.addRangeDayCssClass();
                                e.stopPropagation();
                            })
                            .on('shown.bs.modal', (e: any) => {
                                e.stopPropagation();
                            })
                            .on('hide.bs.modal', (e: any) => {
                                e.stopPropagation();
                            })
                            .on('hidden.bs.modal', (e: any) => {
                                e.stopPropagation();
                            });
        this.setEndDate(this.endDate);
    }

    /** Adiciona as classes css no datepicker pois ao criar o component já com o range setado ele não está adicionando as classes automaticamente */
    private addRangeDayCssClass() {
        // Obtendo data inicial e final em milissegundos
        const startDateTime = new Date(this.startDate)?.getTime() ?? null;
        const endDateTime = new Date(this.endDate)?.getTime() ?? null;
        if (!startDateTime || !endDateTime) {
            return;
        }

        // Criando as datas inicial e final
        const startDate = new Date(startDateTime)
        const endDate = new Date(endDateTime)

        let beforeElem: any;
        jQuery('.datepicker').find('.datepicker-days tbody .day').each(function() {
            if (!beforeElem) {
                beforeElem = this;
            }

            // Criando a data do dia do datepicker
            const dateTime: number = jQuery(this).data('date');
            const date = new Date(dateTime);

            if (date.getFullYear() == startDate.getFullYear() && date.getMonth() == startDate.getMonth() && date.getDate() == startDate.getDate()) { // Dia inicial
                jQuery(beforeElem).addClass('selected').addClass('range-start');
            } else if (date.getFullYear() == endDate.getFullYear() && date.getMonth() == endDate.getMonth() && date.getDate() == endDate.getDate()) { // Dia final
                jQuery(beforeElem).addClass('selected').addClass('range-end');
            } else if (dateTime > startDateTime && dateTime < endDateTime) { // Dia dentro do range
                jQuery(beforeElem).addClass('range');
            }

            beforeElem = this;
        });
    }


    /** Seta data inicial do range */
    setStartDate(date: Date) {
        if (date) {
            this.datepickerStart.datepicker('update', new Date(date));
        } else {
            this.inputDateStart.nativeElement.value = '';
        }
    }

    /** Seta data final do range */
    setEndDate(date: Date) {
        if (date) {
            this.datepickerEnd.datepicker('update', new Date(date));
        } else {
            this.inputDateEnd.nativeElement.value = '';
        }
    }

    /** Ao alterar a data inicial */
    private async onChangeDateStart(e: any) {
        const date = e.date as Date;

        this.startDate = date;
        this.startDateChange.emit(this.startDate);
    }

    /** Ao alterar a data final */
    private async onChangeDateEnd(e: any) {
        const date = e.date as Date;

        this.endDate = date;
        this.endDateChange.emit(this.endDate);
    }

    onKeyupDateStart(event: KeyboardEvent) {
        if (this.ignoresKeys.includes(event.key)) {
            return;
        }

        this.isInputStartValueChanged = true;
    }

    onBlurDateStart(value: string) {
        // Se o valor do input for vazio, então setamos o valor do ngModel para null
        if (!value || value.trim().length === 0) {
            this.startDate = null;
            this.startDateChange.emit(this.startDate);
        } else if (this.isInputStartValueChanged) { // Se não, se o valor no input foi alterado, setamos a data informada no input
            this.datepickerStart.datepicker('setDate', value);
            this.datepickerStart.datepicker('update');
        }
    }

    onKeyupDateEnd(event: KeyboardEvent) {
        if (this.ignoresKeys.includes(event.key)) {
            return;
        }

        this.isInputEndValueChanged = true;
    }

    onBlurDateEnd(value: string) {
        // Se o valor do input for vazio, então setamos o valor do ngModel para null
        if (!value || value.trim().length === 0) {
            this.endDate = null;
            this.endDateChange.emit(this.endDate);
        } else if (this.isInputEndValueChanged) { // Se não, se o valor no input foi alterado, setamos a data informada no input
            this.datepickerEnd.datepicker('setDate', value);
            this.datepickerEnd.datepicker('update');
        }
    }

    private destroyDatepicker(datepicker: any) {
        datepicker.datepicker('destroy');
        datepicker.off('changeDate');
        datepicker.off('show.bs.modal');
        datepicker.off('shown.bs.modal');
        datepicker.off('hide.bs.modal');
        datepicker.off('hidden.bs.modal');
        datepicker = null;
    }

    /** Remove o datepicker */
    private destroy() {
        this.destroyDatepicker(this.datepicker);
        this.destroyDatepicker(this.datepickerStart);
        this.destroyDatepicker(this.datepickerEnd);

        this.inputDateRange.nativeElement.value = '';
        this.inputDateStart.nativeElement.value = '';
        this.inputDateEnd.nativeElement.value = '';
    }

    ngOnDestroy() {
        this.destroy();
    }
}
